import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../lib/AuthContext";

export const ProtectedRoute = ({ allowed, children }) => {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="animate-spin text-[#f28a16]" /></div>;
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  // Legacy: /admin routes historically only allowed role="admin". After the
  // RBAC migration, both "manager" and "office_admin" must reach /admin too
  // (fine-grained protection is done server-side).
  const effectiveAllowed = allowed && allowed.includes("admin")
    ? [...allowed, "manager", "office_admin"]
    : allowed;
  if (effectiveAllowed && !effectiveAllowed.includes(user.role)) {
    const home = {
      manager: "/admin", admin: "/admin", office_admin: "/admin",
      fitter: "/team", client: "/client",
    }[user.role] || "/";
    return <Navigate to={home} replace />;
  }
  return children;
};

export default ProtectedRoute;
